import { BackendStatusData } from './GalenData/BackendStatus.model';
import { DeviceDataValue } from './GalenData/DeviceDataValue.model';
import { GlobalStatus, ModelStatus } from './GalenData/DeviceDataView.model';

const defaultModelStatus: DeviceDataValue<ModelStatus> = {
  value: ModelStatus.NA,
};

export const defaultBackendStatus: BackendStatusData = {
  GlobalStatus: { value: GlobalStatus.Null },
  SessionId: { value: '' },
  DrusStatus: defaultModelStatus,
  DreuStatus: defaultModelStatus,
  AmdeuStatus: defaultModelStatus,
  GlaucomaeuStatus: defaultModelStatus,
  CvdeuStatus: defaultModelStatus,
  CvdauStatus: defaultModelStatus,
  AmdeuSmallStatus: defaultModelStatus,
  DreuSmallStatus: defaultModelStatus,
  GlaucomaeuSmallStatus: defaultModelStatus,
  CvdeuSmallStatus: defaultModelStatus,
  CvdauSmallStatus: defaultModelStatus,
  VesselSegStatus: defaultModelStatus,
};
